import { createSelector } from 'reselect';
import { values } from 'ramda';

const getData = (state) => state.employeesContracts || {};

export const selectEmployeesContractsList = createSelector(
  getData,
  ({ list }) => list
);

export const selectAllEmployeesContractsList = createSelector(
  getData,
  ({ allContracts }) => allContracts
);

export const selectEmployeesContractsById = createSelector(
  selectEmployeesContractsList,
  (_, userId) => userId,
  (list, id) => values(list[id]) || []
);

// SAVE_EMPLOYEE_CONTRACTS sets list[userId] (even to an empty list) once that user's contracts
// have actually been fetched, so list[id] !== undefined means "loaded", not "has contracts".
export const selectEmployeesContractsLoadedById = createSelector(
  selectEmployeesContractsList,
  (_, userId) => userId,
  (list, id) => list[id] !== undefined
);

export const selectEmployeesContractsPending = createSelector(
  getData,
  ({ pending }) => pending
);

export const selectEmployeesContractsMultipleFetching = createSelector(
  getData,
  ({ multipleUpdateFetching }) => multipleUpdateFetching
);